<template>
  <div class="binding">
    <login-header v-bind="headerInfo"></login-header>
    <div class="content" v-loading="loading" v-if="bindToken">
      <el-steps :active="pro" finish-status="success" align-center>
        <el-step title="绑定账号"></el-step>
        <el-step title="验证"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>
      <div class="user_form">
        <div>
          <el-form :model="passForm"  label-width="100px">
            <el-form-item label="手机号：" v-if="pro==1">
              <el-input v-model="passForm.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="验证码：" v-if="pro==2 && !is_reg" class="pass_code">
              <el-input v-model="passForm.code" placeholder="请输入验证码"></el-input>
              <el-button @click="getCode" :disabled="codeContent!='发送验证码'">{{codeContent}}</el-button>
            </el-form-item>
            <el-form-item label="新密码：" v-if="pro==2 && !is_reg">
              <el-input type="password" v-model="passForm.newPwd" placeholder="请输入新密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码：" v-if="pro==2 && !is_reg">
              <el-input type="password" v-model="passForm.confirmPwd" placeholder="请输入确认密码"></el-input>
            </el-form-item>
            <el-form-item label="登录密码：" v-if="pro==2 && is_reg">
              <el-input type="password" v-model="passForm.pwd" placeholder="请输入确认密码"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="pro==3" class="success_info">
          <div>
            <i class="el-icon-circle-check-outline"></i>
            <span>绑定成功！</span>
          </div>
        </div>
        <div class="next_btn">
          <el-button @click="nextPro" v-if="pro!=3">下一步</el-button>
        </div>
      </div>
    </div>
    <div class="content" v-else v-loading="loginLoading" element-loading-text="登录中..." element-loading-spinner="el-icon-loading">
    </div>
    <login-footer :description="desc"></login-footer>
  </div>
</template>

<script>
// 头部模块
import loginHeader from '../header'
// 底部模块
import loginFooter from '../footer'
// 滑动验证模块
import qs from 'qs'

export default {
  name: 'login',

  // 导入子组件
  components: {
    loginHeader, // 头部模块
    loginFooter // 底部模块
  },

  data() {
    return {
      bind_type: '', // 是qq绑定还是微信绑定
      headerInfo: { // 头部
        type: '绑定账号',
        userDisplayFlag: false,
        userName: '',
        logo: ''
      },
      desc: '', // 底部
      pro: 1, // 进度
      is_reg: '', // true 老用户 false 新用户
      bindToken: '', // 第一次绑定token值
      loginToken: '', // 绑定过token值
      codeContent: '发送验证码', // 发送验证码按钮内容
      time: 10, // 发送验证码倒计时
      timeId: null, // timeid
      passForm: {
        phone: '', // 手机号
        code: '', // 验证码
        newPwd: '', // 新密码
        confirmPwd: '', // 确认密码
        pwd: '' // 登录密码
      },
      loading: false,
      loginLoading: false // 自动登录的加载
    }
  },
  created() {
    // 判断是微信绑定还是QQ绑定
    if (this.$route.name == 'bindQq') {
      this.bind_type = 'qq'
    } else if (this.$route.name == 'bindWx') {
      this.bind_type = 'wx'
    }

    // 已经绑定过手机号
    if (this.$route.query.loginToken) {
      this.loginLoading = true
      this.loginToken = this.$route.query.loginToken
      this.autoLog() // 自动登录
    };
    // 未绑定过手机号
    this.bindToken = this.$route.query.bindToken ? this.$route.query.bindToken : ''
  },
  methods: {
    nextPro() { // 输入手机号 点击下一步
      this.loading = true
      if (this.pro == 1) {
        this.checkPhone() // 第一步输入手机号绑定
      } else if (this.pro == 2 && !this.is_reg) {
        this.bindNew() // 新用户输密码绑定
      } else if (this.pro == 2 && this.is_reg) {
        this.bindOld() // 老用户输密码绑定
      }
    },
    getCode() { // 发送验证码
      var that = this
      this.codeContent = this.time + 'S'
      // 倒计时1分钟
      this.timeId = setInterval(() => {
        this.time = this.time - 1
        this.codeContent = this.time + 'S'
        if (this.time < 0) {
          window.clearInterval(this.timeId)
          this.timeId = null
          this.codeContent = '发送验证码'
          this.time = 10
        }
      }, 1000)
      // 发送验证码请求
      QM.apinew({
        url: '/seller/account/send-sms',
        method: 'POST',
        data: {
          mobile: that.passForm.phone
        },
        success: function (xdata) {
          // console.log(xdata)
        },
        error: function (xdata) {
          that.$message.error(xdata.message)
        }
      })
    },
    checkPhone() { // 绑定手机号请求封装
      var that = this
      QM.apinew({
        url: '/seller/account/check-phone-num',
        method: 'GET',
        data: {
          mobile: that.passForm.phone
        },
        success: function (xdata) {
          that.is_reg = xdata.data.is_reg
          that.pro = 2
          that.loading = false
        },
        error: function (xdata) {
          that.$message.error(xdata.message)
          that.loading = false
        }
      })
    },
    bindNew() { // 绑定新用户输入密码请求封装
      var that = this
      QM.apinew({
        url: '/seller/account/bind-new-user',
        method: 'POST',
        data: {
          mobile: that.passForm.phone,
          password: that.passForm.confirmPwd,
          codeValue: that.passForm.code,
          bindToken: that.bindToken,
          type: that.bind_type
        },
        success: function (xdata) {
          that.pro = 3
          that.loading = false
          localStorage.setItem('mobile', that.passForm.phone)
          localStorage.setItem('mytoken', xdata.data.id)
          // 绑定成功跳转
          setTimeout(() => {
            that.$router.push('/')
          }, 3000)
        },
        error: function (xdata) {
          that.$message.error(xdata.message)
          that.loading = false
        }
      })
    },
    bindOld() { // 绑定老用户输入密码请求封装
      var that = this
      QM.apinew({
        url: '/seller/account/bind-old-user',
        method: 'POST',
        data: {
          mobile: that.passForm.phone,
          password: that.passForm.pwd,
          bindToken: that.bindToken,
          type: that.bind_type
        },
        success: function (xdata) {
          that.pro = 3
          that.loading = false
          localStorage.setItem('mobile', that.passForm.phone)
          localStorage.setItem('mytoken', xdata.data.id)
          // 绑定成功跳转
          setTimeout(() => {
            that.$router.push('/')
          }, 3000)
        },
        error: function (xdata) {
          that.$message.error(xdata.message)
          that.loading = false
        }
      })
    },
    autoLog() { // 自动登录封装
      var that = this
      QM.apinew({
        url: '/seller/account/login-by-login-token',
        method: 'POST',
        data: {
          loginToken: that.loginToken
        },
        success: function (xdata) {
          localStorage.setItem('mobile', xdata.data.mobile)
          localStorage.setItem('mytoken', xdata.data.id)
          // 绑定成功跳转
          setTimeout(() => {
            that.loginLoading = false
            that.$router.push('/')
          }, 1000)
        },
        error: function (xdata) {
          that.$message.error(xdata.message)
          that.loginLoading = false
        }
      })
    }
  }

}
</script>

<style scoped>
/* .yellow-btn{
  text-align: center;
  line-height: 50px;
}
.yellow-btn:hover{
  background: #fde36d;
} */
.content{
  padding-top: 100px;
  padding-bottom: 50px;
}
.content >>> .el-step__head.is-success{
  color: #fff;
  border-color: #ffd100;
}
.content >>> .el-step__head.is-success .el-step__icon.is-text {
  background-color: #ffd100;
}
.content >>> .el-step__title.is-success {
  color: #ffd100;
  font-size: 14px;
}
.content >>> .el-step__icon{
  width: 35px;
  height: 35px;
}
.content >>> .el-step.is-horizontal .el-step__line {
  top: 17px;
  background: #e5e6e5;
}
.content >>> .el-step__icon{
  font-size: 16px;
}
.content >>> .el-step__head.is-process,.content >>> .el-step__head.is-wait{
  color: #b8b7b6;
  border-color: #e5e6e5;
}
.content >>> .el-step__head.is-process .el-step__icon.is-text, .content >>> .el-step__head.is-wait .el-step__icon.is-text{
  background-color: #e5e6e5;
}
.content >>> .el-step__title.is-process, .content >>> .el-step__title.is-wait{
  color: #b8b7b6;
  font-weight: normal;
  font-size: 14px;
}
.user_form{
  /* text-align: center; */
  width: 450px;
  margin: 0 auto;
  padding-top: 80px;
}
.el-input{
  width: 250px;
}
.pass_code .el-input{
  width: 133px;
}
.pass_code .el-button{
  width: 114px;
}
.next_btn{
  text-align: center;
  padding-top: 70px;
}
.next_btn .el-button{
  width: 120px;
  background: #ffd100;
  color: #fff;
  border-color: #ffd100;
}
.next_btn .el-button:hover{
  background: #fde36d;
  border-color: #fde36d;
}
.success_info{
  text-align: center;
  padding-top: 30px;
}
.success_info i{
  display: inline-block;
  vertical-align: middle;
  font-size: 50px;
  color: #2cd24b;
}
.success_info span{
  display: inline-block;
  font-size: 18px;
  color: #333;
  font-weight: bold;
}
</style>